function getElementById(id) {
  const element = document.getElementById(id);
  if (!element) window.requestAnimationFrame(() => getElementById(id));
  return element;
}

export default getElementById;
